import { FederalLawCodesEnum } from 'APIPackage/CatalogsModule/enums/FederalLawCodesEnum';

export type FederalLawAccessibility = {
  isPm?: boolean;
  isErknm: boolean;
  isErp: boolean;
};

export const availableFederalLaws: Partial<Record<FederalLawCodesEnum, FederalLawAccessibility>> = {
  [FederalLawCodesEnum.FZ_28]: {
    isErknm: false,
    isErp: true,
    isPm: false,
  },
  [FederalLawCodesEnum.FZ_68]: {
    isPm: false,
    isErknm: false,
    isErp: true,
  },
  [FederalLawCodesEnum.FZ_131]: {
    isErknm: false,
    isErp: true,
  },
  [FederalLawCodesEnum.FZ_248]: {
    isPm: true,
    isErknm: true,
    isErp: false,
  },
  [FederalLawCodesEnum.FZ_294]: {
    isErknm: false,
    isErp: true,
  },
  [FederalLawCodesEnum.FZ_414]: {
    isErknm: false,
    isErp: true,
  },
  [FederalLawCodesEnum.FZ_170]: {
    isErknm: false,
    isErp: true,
    isPm: false,
  },
};
